// geo-content-ref-context.ts — Geo suite, the stored record in scope.
//
// A map block resolves its place names by asking the back end about the RECORD
// it lives in, never by sending the place strings themselves: `/api/geo/resolve`
// is a public route whose body is a reference to already-stored content, and
// that is the only reason it can be public at all. So the renderer needs to know
// which record it is inside — and `Cmarkdown` has around a dozen call sites, of
// which only two render stored session content.
//
// Hence a context defaulting to **null**. Null is the correct and common answer:
// legal copy, team descriptions, model stats and the teams gallery have no
// content ref, and a map inside them simply has no resolution channel. Nothing
// at those call sites changes, and none of them can accidentally acquire one.

'use client';

import { createContext, useContext } from 'react';
import type { GeoContentRef } from '@cabal/shared/domain/geo/types.js';

export const GeoContentRefContext = createContext<GeoContentRef | null>(null);

/** The record whose content this subtree renders, or null when there is none. */
export function useGeoContentRef(): GeoContentRef | null {
  return useContext(GeoContentRefContext);
}
